import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBm4ImportantPlaces } from '../../services/vatandasApi';

// Önemli yerleri getirme
export const fetchImportantPlaces = createAsyncThunk(
  'vatandasImportantPlaces/fetchImportantPlaces',
  async () => {
    const response = await fetchBm4ImportantPlaces();
    return response.data;
  }
);

const vatandasImportantPlacesSlice = createSlice({
  name: 'vatandasImportantPlaces',
  initialState: {
    placesList: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImportantPlaces.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchImportantPlaces.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.placesList = action.payload;
      })
      .addCase(fetchImportantPlaces.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default vatandasImportantPlacesSlice.reducer;

